import { CaretakerOffer } from '$domain/model/caretaker/caretakerOffersList/caretakerOffersList.model'
import { CaretakerLocation } from '$domain/model/caretaker/caretakersLocation/caretakersLocation.model'
import { CaretakerView } from '$domain/model/caretaker/caretakerList/caretakerList.model'

const createHTMLMapMarker = ({ OverlayView = google.maps.OverlayView, ...args }) => {
  class HTMLMapMarker extends OverlayView {
    latlng: google.maps.LatLng
    html: HTMLElement
    div: any
    offer: CaretakerOffer
    caretaker: CaretakerLocation | CaretakerView

    constructor() {
      super()
      this.offer = args.offer
      this.caretaker = args.caretaker
      this.latlng = args.latlng
      this.html = args.html
      this.setMap(args.map)
    }

    createDiv() {
      this.div = document.createElement('div')
      this.div.style.position = 'absolute'
      this.div.style.cursor = 'pointer'
      if (this.html) {
        this.div.innerHTML = this.html
      }
      this.div.addEventListener('click', () => {
        google.maps.event.trigger(this, 'click')
      })
    }

    appendDivToOverlay() {
      const panes = this.getPanes()
      panes.overlayMouseTarget.appendChild(this.div)
    }

    positionDiv() {
      const point = this.getProjection().fromLatLngToDivPixel(this.latlng)
      const offsetX = this.div.clientWidth / 2
      const offsetY = this.div.clientHeight

      if (point) {
        this.div.style.left = `${point.x - offsetX}px`
        this.div.style.top = `${point.y - offsetY}px`
      }
    }

    draw() {
      if (!this.div) {
        this.createDiv()
        this.appendDivToOverlay()
      }
      this.positionDiv()
    }

    editHtml(html) {
      if (this.div) {
        this.html = html
        this.div.innerHTML = this.html
      }
    }

    onRemove() {
      if (this.div) {
        this.div.parentNode.removeChild(this.div)
        this.div = null
      }
    }

    getPosition() {
      return this.latlng
    }

    getDraggable() {
      return false
    }

    getOffer() {
      return this.offer
    }

    getCaretaker() {
      return this.caretaker
    }
  }

  return new HTMLMapMarker()
}

export default createHTMLMapMarker



// WEBPACK FOOTER //
// ./src/utils/htmlMapMarker.ts